export const createObserver = (callback: IntersectionObserverCallback): IntersectionObserver =>
  new IntersectionObserver(callback, {
    root: null,
    threshold: 1.0,
  });
